import { startOfDay } from 'date-fns'

export function startsAfterEnd(start: Date, end: Date, hourly: boolean) {
  if (hourly) return start >= end
  return startOfDay(start) > startOfDay(end)
}
